// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PRICE_IS_DISPLAYED_FOR = "cena je aktu\u00e1ln\u00ed";
export const PRICE_WAS_DISPLAYED_FOR = "cena byla aktu\u00e1ln\u00ed";
